import { css, styled } from 'styled-components';

import {
    CommonAction,
    designColor,
    recipesCommonAction,
    styledMedia,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './FilterChip.tokens.ts';

interface ActionProps {
    $variant?: 'toggle' | 'dismiss';
}

export const Action = styled(CommonAction)<ActionProps>`
    ${recipesCommonAction.basic};
    --filter-chip-weight: 700;
    --filter-chip-color: rgb(255, 255, 255, 1);

    flex: 0 0 auto;
    gap: ${tokens.action.gap}px;
    padding-left: ${tokens.action.padding}px;
    padding-right: ${tokens.action.padding}px;
    height: ${tokens.action.height}px;
    background-color: rgb(255, 255, 255, 0.1);

    &:disabled {
        opacity: 0.8;
    }

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.16);
    }

    ${({ $variant }) =>
        $variant === 'toggle' &&
        css`
            --filter-chip-weight: 600;
            --filter-chip-color: rgb(255, 255, 255, 0.8);

            &[aria-pressed] {
                --filter-chip-color: rgb(255, 255, 255, 1);
                background-color: ${designColor.brandPurple};

                &:hover:not(:active) {
                    background-color: ${designColor.brandPurpleDark};
                }
            }
        `};
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.label.size}px;
    font-weight: var(--filter-chip-weight);
    letter-spacing: -0.02em;
    text-transform: capitalize;
    color: var(--filter-chip-color);
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.icon.size}px;
    height: ${tokens.icon.size}px;
`;

export const Badge = styled.div`
    display: grid;
    place-items: center;
    place-content: center;
    min-width: ${tokens.badge.size}px;
    height: ${tokens.badge.size}px;
    border-radius: 999px;
    background-color: rgb(255, 255, 255, 0.1);

    &:last-child {
        margin-right: ${(tokens.action.padding / 2) * -1}px;
    }
`;

export const BadgeLabel = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    padding: 0 ${tokens.badge.padding}px;
    font-size: ${tokens.badge.fontSize}px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    text-transform: capitalize;
    color: rgb(255, 255, 255, 0.8);
`;

///
/// Filter Chip List

export const List = styled.ul`
    ${styledReset.list};
    display: flex;
    flex-wrap: wrap;
    gap: ${tokens.action.gap}px;
`;

export const Item = styled.li``;
